<script lang="ts">

	export let value
	
	function formatValue(value) {
		const date = new Date(value || undefined)
		const month = `${date.getMonth() + 1}`.padStart(2, '0')
		const day = `${date.getDate()}`.padStart(2, '0')
		const hours = `${date.getHours()}`.padStart(2, '0')
		const minutes = `${date.getMinutes()}`.padStart(2, '0')
		return `${date.getFullYear()}-${month}-${day}T${hours}:${minutes}`
	}
	
	function onChange(event) {
		const input = event.target
		value = input.value
	}

	
</script>


<input class="form-control" type="datetime-local" value={formatValue(value)} on:change={onChange}>